import { render, staticRenderFns } from "./customer-notifications.vue?vue&type=template&id=68cca389&scoped=true"
import script from "./customer-notifications.vue?vue&type=script&lang=js"
export * from "./customer-notifications.vue?vue&type=script&lang=js"
import style0 from "./customer-notifications.vue?vue&type=style&index=0&id=68cca389&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cca389",
  null
  
)

export default component.exports